(function () {
  window.userService = {
    login(data) {
      return axios.post(`/api/user/login.php`, {
        email: data.email,
        password: data.password,
      });
    },
    logout() {
      return axios.get(`/api/user/logout.php`);
    },
    get(data) {
      return axios.get(
        `/api/user/get.php?twitchId=${
          data ? data.userId : utils.cookies.get('user_id')
        }`
      );
    },
    create() {
      return axios.post('/api/user/create.php', {
        twitchId: utils.cookies.get('user_id'),
        twitchLogin: utils.cookies.get('user_login'),
        twitchDisplayName: utils.cookies.get('user_display_name'),
        twitchEmail: utils.cookies.get('user_email'),
        twitchProfileImage: utils.cookies.get('user_profile_image'),
      });
    },
    update() {
      return axios.post('/api/user/update.php', {
        twitchId: utils.cookies.get('user_id'),
        twitchLogin: utils.cookies.get('user_login'),
        twitchDisplayName: utils.cookies.get('user_display_name'),
        twitchEmail: utils.cookies.get('user_email'),
        twitchProfileImage: utils.cookies.get('user_profile_image'),
        theme: utils.cookies.get('theme'),
      });
    },
    getToken(data) {
      return axios.post('/api/token/get.php', {
        redirectUrl: data.redirectUrl,
        code: data.code,
      });
    },
    refreshToken() {
      return axios.post('/api/token/validate.php', {});
    },
    search(data) {
      return axios.post('/api/user/search.php', {
        twitchDisplayName: data.twitchDisplayName,
      });
    },
    stats() {
      return axios.get(
        `/api/user/stats.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    useSpecialCard(data) {
      return axios.post('/api/user/specialcard/active.php', {
        twitchId: data.fromId,
      });
    },
    getCards(data) {
      return axios.get(
        `/api/user/card/get.php?twitchId=${data.twitchId}&unlockQueueId=${data.id}`
      );
    },
    getKeys() {
      return axios.get(
        `/api/user/key/get.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    getDogTags() {
      return axios.get(
        `/api/user/tags/get.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    saveCards(data) {
      console.log(data)
      return axios.post('/api/user/card/save.php', {
        twitchId: data.twitchId,
        unlockQueueId: data.unlockQueueId,
        cardId: data.cardId,
        tier: data.tier,
        value: data.value,
      });
    },
    unlockedCards() {
      return axios.get(
        `/api/user/card/unlocked.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    addRemoveToFavorites(data){
      return axios.post('/api/user/card/add_to_favorites.php', {
        twitchId: data.twitchId,
        cardNumber: data.cardNumber,
        addRemove: data.add,
        dateCreated: data.dateCreated,
      });
    },
    getFavorites(){
      return axios.get(
        `/api/user/card/favorites.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    equipBoneCard(data){
      return axios.post('/api/user/card/equip_bone.php', {
       twitchId: data.twitchId,
       cardNumber: data.card, 
       boneId: data.bonecard, 
       dateCreated: data.dateCreated, 

      });
    },
    getBoneCards(){
      return axios.get(
        `/api/user/card/bone.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    verifyCards(data) {
      let cards = data.cards;
      cards = cards.join('-');
      cards = cards.replace(/#/g, '');
      return axios.get(
        `/api/user/card/verify.php?twitchId=${data.twitchId}&cards=${cards}`
      );
    },
    getLeaderboard() {
      return axios.get(`/api/leaderboard/get.php`);
    },
    getTeams(data) {
      return axios.get(
        `/api/user/team/get.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    saveTeam(data) {
      data.twitchId = utils.cookies.get('user_id');
      return axios.post('/api/user/team/save.php', data);
    },
    deleteTeam(data) {
      data.twitchId = utils.cookies.get('user_id');
      return axios.post('/api/user/team/delete.php', data);
    },
    addMod(data) {
      return axios.post('/api/user/mod.php', data);
    },
    getStreamerBattleState() {
      return axios.get(
        `/api/user/streamer-battle-get.php?twitchId=${utils.cookies.get(
          'user_id'
        )}`
      );
    },
    getSteamerQueue() {
      return axios.get(
        `/api/streamer/get-queue.php?streamerTwitchId=${utils.cookies.get(
          'user_id'
        )}`
      );
    },
    toggleStreamerBattle(data) {
      data.twitchId = utils.cookies.get('user_id');
      return axios.post('/api/user/streamer-battle-active.php', data);
    },
    joinStreamerTeamQueue(data) {
      return axios.post('/api/streamer/join-queue.php', data);
    },
    leaveStreamerTeamQueue(data) {
      return axios.post('/api/streamer/leave-queue.php', data);
    },
    declineUserTeam(data) {
      return axios.post('/api/streamer/decline-queue.php', data);
    },
    acceptUserTeam(data) {
      return axios.post('/api/streamer/join.php', data);
    },
    getTeamCardInfo(data){
      data.twitchId = utils.cookies.get('user_id');
      return axios.post('/api/user/team/get-team-stats.php', data);
    },
    getUserBark(id){
      return axios.get(
        `/api/user/barks/get.php?twitchId=${utils.cookies.get(
          'user_id'
        )}`
      );
    },
    getAscension(){
      return axios.get(
        `/api/user/card/ascnension.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    getInventory(){
      return axios.get(
        `/api/user/card/inventory.php?twitchId=${utils.cookies.get('user_id')}`
      );
    },
    openJewelryF(data){
      data.active = true;
      return axios.post('/api/store/save.php', data);
    },
    upgradeTier(data){

      return axios.post('/api/user/card/upgrade_tier.php', data);
    },
    userStoreActive(data){
      return axios.post('/api/store/save.php', data);
    },
    spiritForge(data){
      return axios.post('/api/store/save.php', data);
    },
    getStats(){
      return axios.get(
      `/api/user/stats/get.php?twitchId=${utils.cookies.get('user_id')}`
      );
    }
  };
})();
